import Vue from "vue"
import Vuex from "vuex"
import actions from "./action"
import mutations from "./mutations"
// creatrLogger通过mutation修改state会打印日志，看到state之前之后的变化
import creatrLogger from "vuex/dist/logger"

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== "production"

export default new Vuex.Store({
    state: {
        brand: '萌爪',
        profile: null, //B端合作参数
        isMobile: false,
        canJumpMinni: false,
        version: null,
        partnerPromotionString: 'reddog20201109',
        partner: 'reddog',
        noActivity: true,
        // 会员价格
        membershipPrice: {
            svip: 399,
            vip1Year: 349,
            vip3Months: 199,
            TempVip: 79
        },
        origin: ``,
        originAppointment: `/appointment`,
        vetTime: null,
        imgList: [],
        ownerView: null,
        userProfile: null, // 用户的完整信息
        vipUserInfo: {}, // vip用户信息
        petView: {},
        petList: [],
        // 会员信息是否完整
        completeInformation: null,
        // 用户身份
        userIdentity: null,
        // 是不是兽医
        canViewVet2: null,
        sharePageImage: "",
        time: 1564848000000, // 新会员 价格调整 定义时间
        // 项目中可以减少的请求集合
        session: {
            // 关注服务号只请求一次
            isService: false,
            // 咨询详情页里边通知开关
            isShowServiceQuery: false,
            // 首页服务号通知开关
            isShowServiceMain: false
        }
    },

    actions,
    mutations,
    plugins: debug ? [creatrLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js